import React from 'react'
import { esES as esESMaterial } from '@material-ui/core/locale'


export const esES = {
    ...esESMaterial,
    props: {
        ...esESMaterial.props,
        MFCustomizedStepper: {
            texts: [{ texto: 'DATOS PERSONALES' }, { texto: 'VALIDACIÓN' }, { texto: 'DATOS ADICIONALES' }, { texto: 'OFERTA' }],
        },
        VDNPSimulador: {
            subtitle: 'Nuestras soluciones inteligentes ayudan a fortalecer tus finanzas y a darte confianza.',
            heroBadge: 'Préstamos personales a tu alcance',
            heroTitlePrefix: 'El préstamo que necesitas,',
            heroTitleAccent: 'fácil, rápido',
            heroTitleSuffix: 'y seguro.',
            heroSubtitleText: 'Nuestras soluciones inteligentes ayudan a fortalecer tus finanzas y a darte confianza.',
            heroImageAlt: 'Pareja revisando información en una tableta',
            simulatorCardTitle: 'Calcula tu préstamo',
            simulatorCardSubtitle: 'Ingresa los valores y conoce tu pago estimado al instante.',
            postalCodeLabel: 'Código postal',
            postalCodePlaceholder: 'Ej. 94520',
            postalCodeErrorText: 'Se aceptan solo 5 dígitos',
            loanAmountLabel: 'Monto del préstamo*',
            amountRangeMinLabel: 'Mínimo',
            amountRangeMaxLabel: 'Máximo',
            coverageUnavailableText: 'Lo sentimos, actualmente no tenemos disponibilidad en esa zona.',
            paymentFrequencyLabel: 'Frecuencia de pago',
            monthlyLabel: 'Mensual',
            biweeklyLabel: 'Catorcenal',
            termLabel: 'Plazo (meses)',
            estimatedPaymentMonthlyLabel: 'Pago estimado mensual',
            estimatedPaymentBiweeklyLabel: 'Pago estimado catorcenal',
            continueButtonText: 'Continuar solicitud',
            simulatorFooterHint: '*Sujeto a aprobación de crédito. Calculadora con fines ilustrativos.',
            benefitsEyebrow: 'Beneficios',
            benefitsTitlePrefix: '¿Por qué',
            benefitsTitleAccent: 'elegirnos?',
            benefitsSubtitleText: 'Hacemos que el proceso sea simple, transparente y diseñado para tu comodidad.',
            benefitOneTitle: 'Requisitos sencillos para solicitar',
            benefitOneLine1: '- Identificación oficial vigente.',
            benefitOneLine2: '- Comprobante reciente de ingresos.',
            benefitOneLine3: '- Comprobante reciente de domicilio.',
            benefitTwoTitle: 'Aplica en línea',
            benefitTwoLine1: 'Obtén tu préstamo de forma presencial o, si cumples con los requisitos de elegibilidad, mediante depósito directo a tu tarjeta de débito, de manera rápida y sin complicaciones.',
            benefitThreeTitle: 'La comodidad para hacer tus pagos',
            benefitThreeLine1: 'Acceso a tu cuenta las 24 horas del día desde',
            benefitThreeLine2: 'donde te encuentres a través de nuestra APP',
            benefitThreeLine3: 'Apoyo Financiero Mobile.',
            benefitThreeLinkText: 'Descárgala aquí.',
            testimonialsEyebrowText: 'Testimonios',
            testimonialsTitlePrefix: 'Lo que dicen',
            testimonialsTitleAccent: 'nuestros clientes',
            testimonialsSubtitleText: 'Más de 90,000 personas ya han transformado su futuro financiero con nosotros.',
            alertServiceUnavailable: 'Lo sentimos, por el momento el servicio no se encuentra disponible',
            inactiveBusinessAlert: 'Lo sentimos, el establecimiento esta desactivado, se continuara con una solicitud normal',
            modalTitleSorry: 'Lo sentimos',
            modalBodyAge: 'No tienes la antigüedad mínima para acceder a un crédito. Gracias.'
        },
        VDNPFooterAfi: {
            brandName: 'Apoyo Financiero',
            brandText: 'Comprometidos con la comunidad latina en Estados Unidos. Soluciones financieras accesibles, transparentes y con corazón.',
            customerServiceLabel: 'Atención al cliente',
            customerServiceHours: 'Lun - Sáb | 8am - 8pm',
            companySectionTitle: 'Empresa',
            legalSectionTitle: 'Legal',
        },
        VDPNValidacionIdentidadAfi: {
            topCopyTitle: "Formulario de Solicitud",
            titleIconCredito: "Verificación de crédito",
            boxMessage1: "Con tu firma, nos autorizas obtener informes de tu historial de crédito, empleo y domicilio relacionados con tu solicitud de crédito, de conformidad con la ley aplicable y nuestra política de privacidad.",
            boxMessage2: <strong>A continuación te pedimos que firmes tal como aparece en tu identificación en el siguiente recuadro:</strong>,
            boxMessage3: "Con su firma, usted autoriza a Apoyo Financiero, Inc. a realizar verificaciones iniciales de su historial crediticio, empleo y dirección relacionados con su solicitud de crédito, de acuerdo con la ley aplicable y nuestro proceso de evaluación crediticia, primero realizaremos una verificación inicial (verificación crediticia suave) para precalificar su solicitud. Esta verificación no afectará su FICO Score. Si cumple con nuestros criterios iniciales, procederemos con una evaluación más detallada, incluida una consulta exhaustiva que puede afectar su puntaje FICO Score.",
            boxMessage4: <strong>Por favor firme como aparece en su identificación en el cuadro a continuación:</strong>,
            buttonDegradeContinue: "Continuar con solicitud",
            alertMessage: "Lo sentimos, por el momento el servicio no se encuentra disponible",
            lblFirmarSolicitud: "Firmar tu solicitud",
            checkBuroTxt: "Autorizo la revisión de mi buró de crédito",
            checkDeclaracionTxt: "He leído, entendido el contenido, aceptado y firmado la declaración.",
            footerHintText: "A continuación, se abrirá un recuadro para que firmes igual que en tu identificación.",
            continueToSignText: "Continuar para firmar",
            signatureHelperText: "Usa el recuadro blanco para realizar tu firma.",
            signatureRetryText: "Reintentar firma",
            signatureSaveText: "Guardar firma",
            closeSignatureModalAriaLabel: "Cerrar modal de firma"
        },
        VDPNSignature: {
            boxTitle: "Escribe tu firma aquí:",
            boxAction: "Borrar",
            msjLienzo: "El trazo de la firma es muy corto",
            modernTitle: "Firma igual que en tu identificación.",
            helperText: "Usa el recuadro blanco para realizar tu firma.",
            retryText: "Reintentar firma"
        },
        VDNPAddressAfi: {
            titleIcon: 'Domicilio',
            typographySubtitle: 'Proporciona los datos de tu vivienda.',
            inputLabelAddress1: 'Dirección 1',
            inputLabelAddress2: 'Dirección 2',
            inputLabelCp: 'Código postal',
            inputErrorMessageCP: 'Se aceptan solo 5 dígitos',
            inputLabelEstado: 'Estado',
            inputPlaceholderAddress1: 'Ej. 123 Main St',
            inputPlaceholderAddress2: 'Ej. Apt 4B',
            inputPlaceholderCp: 'Ej. 90001',
            inputPlaceholderEstado: 'Ej. California'
        },
        VDPNTusDatosAfi: {
            titleIcon: "Datos Personales",
            topCopyTitle: "Formulario de Solicitud",
            topCopySubtitle: "Completa la siguiente información para iniciar tu proceso de préstamo personal.",
            topCopyNote: "Nota: Es importante que tu nombre completo y tu edad coincidan con tu identificación oficial.",
            identitySectionTitle: "Identidad",
            inputLabelName: "Nombre(s)",
            inputHelperTextName: "Ingresa tu(s) nombre(s)",
            inputPlaceholderName: "Ej. Michael",
            inputLabelPaternalLastName: "Apellido paterno",
            inputHelperTextPaternalLastName: "Campo obligatorio",
            inputPlaceholderPaternalLastName: "Ej. Johnson",
            inputLabelMaternalLastName: "Apellido materno",
            inputHelperTextMaternalLastName: "",
            inputPlaceholderMaternalLastName: "Ej. Smith",
            inputLabelPhone: "Teléfono celular",
            inputPlaceholderPhone: "Ej. 3235550182",
            inputLabelEmail: "Correo electrónico",
            inputPlaceholderEmail: "Ej. michael.johnson@gmail.com",
            inputLabelBirthDate: "Fecha de nacimiento",
            inputLabelSsn: "Número SSN",
            inputPlaceholderSsn: "Ej. 123456789",
            inputErrorMessagePhone: 'Debe ingresar un número de 10 dígitos válido',
            inputErrorMessageEmail: "Debe ingresar un correo electrónico válido",
            addressAfiTitle: "Domicilio",
            addressAfiSubtitle: "Proporciona los datos de tu vivienda.",
            modalInfoTitleLoSentimos: "Lo sentimos",
            modalInfoBodyLoSentimosTwo: (state) => <div><p>No contamos con cobertura con el código postal que proporcionaste para {state}.</p><p>Inténtalo nuevamente.</p></div>,
            modalInfoBodyLoSentimos: <div><p>Por el momento no contamos con cobertura en tu ubicación.</p><p>Estamos trabajando para poder atenderte próximamente.</p></div>,
            modalInfoBtnLeftLoSentimos: "INTENTAR DE NUEVO",
            modalInfoBtnRightLoSentimos: "TERMINAR",
            modalInfoTitleCreditCard: "Tarjeta de débito",
            modalInfoBodyFormLabelCreditCard: "Para continuar con la solicitud de tu préstamo es necesario que cuentes con una tarjeta de débito a tu nombre vigente y activa.",
            modalInfoBodyFormControlLabelYesCreditCard: "Sí tengo",
            modalInfoBodyFormControlLabelNoCreditCard: "No tengo",
            alertMessage: "Lo sentimos, por el momento el servicio no se encuentra disponible",
            warningModalTitle: "Campos incompletos",
            warningModalMessage: "Por favor, completa todos los campos obligatorios antes de continuar.",
            warningModalButton: "Aceptar",
            warningModalTermsTitle: "Términos y condiciones",
            warningModalTermsMessage: "Por favor, acepta los términos, condiciones y autorizaciones para continuar.",
            warningModalTermsButton: "Aceptar",
            identityScanTipText: "Escanea tu identificación o captura tus datos tal cual aparecen en tu ID.",
            contactSsnSectionTitle: "Contacto y SSN",
            confirmCardLabel: "Revisa si tus datos están bien escritos:",
            confirmYesLabel: "Sí, confirmar.",
            confirmNoLabel: "No, corregir.",
        },
        VDPNIdScanModalAfi: {
            warningTitle: "Queremos asegurarnos de que todo esté bien",
            warningBody: "Comprueba que tus nombres y apellidos queden exactamente igual a tu identificación (ID, pasaporte o matrícula).",
            warningButton: "Aceptar",
            sourceTitle: "Escanea tu identificación",
            sourceSubtitle: "Usa una identificación oficial vigente: licencia de conducir, ID estatal o pasaporte. Leemos el frente del documento.",
            sourceCameraLabel: "Tomar foto",
            sourceCameraDesc: "Usa la cámara de tu dispositivo",
            sourceGalleryLabel: "Subir desde galería",
            sourceGalleryDesc: "Selecciona una foto guardada",
            cancelLabel: "Cancelar",
            cameraTitle: "Encuadra el frente de tu identificación",
            cameraSubtitle: "Alinea el documento dentro del recuadro. Evita reflejos y asegúrate de que se lean bien los datos.",
            cameraFrameLabel: "Centra el documento dentro del marco",
            captureBtnLabel: "Capturar foto",
            backLabel: "Volver",
            cameraErrorMsg: "No se pudo acceder a la cámara. Verifica los permisos del navegador.",
            tip1: "Foto derecha, sin inclinar",
            tip2: "Superficie oscura y buena luz",
            tip3: "Sin recortes ni bordes tapados",
            loadingTitle: "Leyendo tu identificación...",
            loadingSubtitle: "Esto toma solo unos segundos",
            resultsTitle: "Identificación verificada",
            resultsSubtitle: "Encontramos estos datos en tu documento. Revísalos antes de continuar.",
            resultsLabelNombre: "Nombre(s)",
            resultsLabelApellido: "Apellido paterno",
            resultsLabelApellidoMaterno: "Apellido materno",
            resultsLabelFecha: "Fecha de nacimiento",
            resultsWarning: "Solo leemos el frente del documento. Si tu dirección actual está en el reverso o es distinta a la del documento, complétala manualmente más abajo.",
            useDataLabel: "Usar estos datos",
            retryLabel: "Reintentar foto",
            lowQualityTitle: "No pudimos leer tu documento",
            lowQualityBody: "La imagen tiene demasiado reflejo o está borrosa. Asegúrate de que el documento esté bien iluminado, sin reflejos, y que todos los datos sean visibles.",
            lowQualityRetry: "Intentar de nuevo",
        },
        VDNPDisclousers: {
            AvisosTermsPhone: "Ver Aviso de Privacidad, sección: Comunicaciones Electrónicas",
            buttonDegradeTextButton: "Continuar",
            TermsPhoneLink: "telefonia-movil",
            labelWhats: <span>
                Otorgo mi consentimiento para recibir llamadas telefónicas relacionadas con mi préstamo&nbsp;
                <a id="tus-datos-id-terminos-a-phone" href="/es/telefonia-movil" target="_blank" rel="nofollow noopener noreferrer" style={{ color: "#F8686B" }}><b>Aviso de Telefonía móvil</b></a>,&nbsp;
                notificaciones vía WhatsApp y alertas SMS de Apoyo Financiero. La frecuencia de los mensajes puede variar.
                Pueden aplicar cargos adicionales por envío de mensaje.&nbsp;
                <a id="tus-datos-id-avisos-checkbox" href='/es/terminos-condiciones?option=privacy-notice' rel="nofollow noopener noreferrer" target="_blank" style={{ color: "#F8686B" }}><b>Ver Aviso de Privacidad, sección: Comunicaciones Electrónicas</b></a>
            </span>,
            formControlLabelTerms: <span>
                Acepto los&nbsp;
                <a id="tus-datos-id-terminos-a-phone" href='/es/terminos-condiciones?option=terms-conditions' target="_blank" rel="nofollow noopener noreferrer" style={{ color: "#F8686B" }}><b>Términos y Condiciones de Uso del Sitio Web,</b></a>
                &nbsp;y el&nbsp;
                <a id="tus-datos-id-avisos-checkbox" href='/es/terminos-condiciones?option=privacy-notice-ca' rel="nofollow noopener noreferrer" target="_blank" style={{ color: "#F8686B" }}><b>Aviso de Privacidad</b></a>
            </span>,
            lblAutorizar: "Acepto y autorizo que Apoyo Financiero, Inc. realice la consulta de mi historial crediticio."
        },
        VDNPReferidos: {
            badgeMainText: "Préstamos personales desde $750 hasta $4,000 USD*",
            badgeSubText: "*Sujeto a aprobación de crédito",
            heroImageAlt: "Familia feliz",
            noteHighlight: "Toma nota:",
            noteText: "Nunca te pediremos dinero por adelantado para recibir un préstamo"
        },
        VDNPAfiPreOferta: {
            heroTitleText: '¡Felicidades! Has sido pre-calificado.',
            subtitle: 'Con base en la información que nos has proporcionado, Apoyo Financiero te ofrece las siguientes opciones de préstamo. Selecciona la que más te convenga.',
            nextButtonText: 'Continuar',
            conditionsText: 'Condiciones: Aprobación final sujeta a la verificación de tu información personal y documentos presentados.',
            footerHelpText: '¡Estás muy cerca de obtener el apoyo que necesitas! A continuación deberás realizar algunas verificaciones y cargar tus documentos.',
            amountText: 'Monto',
            paymentText: 'Pago',
            garantiaReqText: 'Garantía Requerída',
            durationText: 'Durante',
            optionLabelPrefix: 'Opción',
            loadingText: 'Cargando...',
            modalTitle: 'Recuerda',
            finishModalTitle: '¡Ya casi tienes tu préstamo!',
            finishModalTextPrimary: 'Solo falta validar tus datos y subir tus documentos para finalizar.',
            finishModalTextSecondary: 'Si no los tienes en este momento podrás completar el proceso más tarde a través de la liga incluida en el SMS que recibiste.',
            finishModalButtonText: 'Continuar',
            finishModalCloseAriaLabel: 'Cerrar modal'
        },
        VDPNNumRastreo: {
            heroTitle: 'tienes tu préstamo!',
            heroTitleHighlight: '¡Ya casi',
            descriptionLine1: 'Solo falta validar tus datos y cargar tus documentos para finalizar.',
            descriptionLine2: 'Si no los tienes en este momento podrás completar el proceso más tarde a través de la liga incluida en el SMS que recibiste.',
            summaryTitle: 'Resumen del préstamo',
            ofertaMonto: 'Monto',
            ofertaPago: 'Pago',
            plazoLabel: "Plazo",
            primaryButtonText: "Continuar"
        },
        VDPNDatosComplementariosAfi: {
            heroTitle: "Formulario de Solicitud",
            heroSubtitle: "Ya estás muy cerca de obtener una respuesta.",
            sectionEconomicsTitle: "Ingresos",
            sectionHousingTitle: "Vivienda",
            sectionPoliticalTitle: "Políticos",
            sectionSocialTitle: "Sociales",
            sectionSocialDisclaimer: 'Como parte de nuestro proceso, le solicitaremos cierta información de carácter voluntario con el objetivo de cumplir con los requisitos federales de reporte y medir nuestro impacto en la comunidad. Proporcionar esta información no afectará la decisión de crédito. Si decide no proporcionar esta información, por favor seleccione "Prefiero no proporcionar esta información."',
            selectPlaceholder: "Selecciona",
            selectPlaceholderLong: "Selecciona una opción...",
            armyHelpText: "Deberás proporcionar SSN, identificación militar y orden de servicio militar para revisión en caso de indicar que eres miembro de las Fuerzas Armadas de U.S.",
            titleIcon: "Datos Complementarios",
            typographySubtitle: '¡YA ESTÁS MUY CERCA DE OBTENER UNA RESPUESTA!',
            titleIconTwo: "¿Cuánto ganas al mes?",
            InputLabelAmount: "Cantidad en dólares",
            InputHelperAmount: "Ingreso Mensual Bruto (antes de impuestos)",
            TooltipLabelAmount: "Puedes incluir ingresos adicionales comprobables como: bonos, comisiones, trabajo de medio tiempo, actividades por tu cuenta, seguro social, child support, pensión alimenticia, etc.",
            RadioLabelYes: "Si",
            RadioLabelNo: "No",
            LabelCurrentAdress: "¿Cuánto tiempo tienes en tu vivienda actual?",
            CurrentAddress: "Tiempo en tu vivienda actual",
            InputLabelInsertAmount: "Insertar Monto",
            InputLabelPreviousAddress: "¿Cuánto tiempo viviste en tu domicilio anterior?",
            SelectLabelPreviousAddress: "Tiempo en tu domicilio anterior",
            InputLabelYourAddressIs: "Tu domicilio es... ",
            RadioLabelRented: "Rentado",
            RadioLabelOwn: "Propio",
            InputLabelPayMonth: "¿Cuánto pagas al mes?",
            InputLabelCurrentJob: "¿Cuánto tiempo tienes en tu trabajo actual?",
            ImputLabelTimeJob: "Tiempo en tu trabajo actual",
            InputLabelEmployer: "¿Cuánto tiempo estuviste en tu trabajo anterior?",
            InputLabelPreviousJob: "Tiempo en tu trabajo anterior",
            ButtonContinueRequest: "Continuar con solicitud",
            InputLabelPayDay: "¿Actualmente estás pagando un préstamo de Día de Pago (PayDay Loan)?",
            InputLabelForceArmy: "¿Eres personal activo o perteneces a las Fuerzas Armadas de U.S.? (Deberás proporcionar SSN, identificación militar y orden de servicio militar para revisión en caso de indicar que eres miembro de las Fuerzas Armadas de U.S.)",
            Alerta: "Lo sentimos, por el momento el servicio no se encuentra disponible.",
            LabelTermsPhone: <span>Al proporcionar tu número de teléfono nos autorizas a recibir mensajes relacionados a tu préstamo. La frecuencia de los mensajes puede variar. Pueden aplicar cargos adicionales por envío de mensaje.</span>,
            AvisosTermsPhone: "Ver Aviso de Privacidad Sección de Comunicaciones Electrónicas",
            phoneEquals: "El teléfono de casa no puede ser igual al teléfono de la empresa actual",
            LabelGender: "Género:",
            labelMen: "Hombre",
            labelWomen: "Mujer",
            labelNotPart: "Prefiero no proporcionar esta información.",
            labelRace: "Raza:",
            labelEtnia: "Etnia:",
            labelSosten: "Sostén de Familia:",
            labelOther: "Otro",
            lblPersonPep: "¿Se te ha confiado actualmente o se te ha confiado anteriormente una función pública destacada, o alguno de tus familiares inmediatos y asociados cercanos; es una persona políticamente expuesta (PEP)?",
            frequencyContextText: "Queremos asegurarnos de tener la información correcta",
            frequencyQuestionPrefix: "¿Cada cuánto recibes estos",
            labelFreqMensual: "Es mi ingreso Mensual total",
            labelFreqQuincenal: "Quincenal (2 veces al mes)",
            labelFreqCatorcenal: "Catorcenal (cada 14 días)",
            labelFreqSemanal: "Me pagan por Semana (4 veces al mes)",
            labelExtraIncome: "¿Tienes algún ingreso extra?",
            labelExtraIncomeType: "Selecciona el tipo de ingreso extra",
            labelExtraIncomeAmount: "¿Cuánto recibes al mes?",
            placeholderExtraAmount: "Ej. $300",
            extraIncomeTypeOpt1: "Incapacidad",
            extraIncomeTypeOpt2: "Taxista",
            extraIncomeTypeOpt3: "Independiente",
            extraIncomeTypeOpt4: "Otro",
            incomeEstimatedText: "Entendido, tu ingreso estimado es de:",
            labelConfirmYes: "Sí, confirmar."
        },
        VDNPTuProceso: {
            amountLabel: 'Monto',
            paymentLabel: 'Pago',
            lbgarantia: "Garantía Requerida",
            errorServiceMessage: 'Lo sentimos, por el momento el servicio no se encuentra disponible.',
            title: 'Progreso de mi solicitud',
            subtitle: 'Tienes acciones pendientes en tu solicitud de préstamo. Revisa cada paso para completarlo y continuar.',
            nextButtonText: 'FINALIZAR PROCESO',
            jumioModalTitle: 'Error en verificación',
            lblRefresh: "Refrescar página",
            helpPhone: '18008912778',
            helpPhoneDisplay: '1-800-891-2778 opción 2'
        },
        VDNPVerificacionProve: {
            textCount1: 'REACTIVANDO LINK EN:',
            textCount2: 'REENVIAR LINK AL:',
            titleIcon: 'Verificación de número telefónico',
            textInfo: 'Para poder continuar con el proceso de solicitud de préstamo, necesitamos validar tu número de teléfono celular. Recibirás un mensaje de texto con un link al número telefónico que nos proporcionaste. Sólo tienes que dar clic en el enlace.',
            textFormHelper: 'No he recibido ningún SMS',
            textButton: 'CONTINUAR',
            errorMessage: 'Lo sentimos, por el momento el servicio no se encuentra disponible',
            textValidateInfo: 'Validando tu información por favor espere....',
            textValidateInfoOk: 'Tu información fue procesada.'
        },
        VDPNPassFico: {
            lblFelicidades: "¡FELICIDADES!",
            lblConbase: "Con base en la información que nos proporcionaste en tu solicitud de préstamo, nos complace informarte que has sido precalificado* para un préstamo de Apoyo Financiero, Inc.",
            lblmonto: "Por un monto de",
            lbgarantia: "Garantía Requerida",
            lblContinuar: "Si deseas continuar con el proceso de solicitud de préstamo, haz clic aquí ",
            btnContinuar: "Continuar",
            lblTenercuenta: "*Ten en cuenta que esta precalificación es solo una evaluación inicial basada en la información que has proporcionado y está sujeta a la revisión completa de tu información, documentación y aprobación crediticia final. El monto de la garantía será verificado antes de la aprobación final."
        },
        VDPNFelicidades: {
            txtInapp: "Entra a la app móvil",
            txtcommentThree: <span><strong>PASO 2. Da clic en el botón para ingresar a tu aplicación móvil</strong><br />La app te guiará paso a paso para completar el proceso del préstamo.</span>,
            txtcommentTwo: <span><strong>PASO 1. Descarga nuestra app móvil</strong><br />Da clic en el botón que corresponde a tu tipo de teléfono celular</span>,
            txtcomment: "Estás a punto de completar el proceso. Por favor procede a descargar la aplicación móvil para completar el desembolso de tu préstamo.",
            FelicidadesTitle: "REGISTRO EN LA APP MÓVIL",
            AppsTitle: "Descarga nuestra APP y maneja tu préstamo fácil, sin filas y sin complicaciones.",
            TitleButtonEncuesta: "¿Nos ayudarías a contestar una breve encuesta para mejorar nuestro servicio al cliente?",
            TitleButton: "TOMAR ENCUESTA",
            TitleMonto: "Monto del Préstamo",
            garantiaMonto: 'Garantía a Retener',
            TitlePago: "Monto del Pago",
            TitlePlazo: "Plazo del Préstamo",
            TitlePrimerPago: "Fecha del primer pago",
            TitleSucursal: "Sucursal",
            alertMessage: "Lo sentimos, por el momento el servicio no se encuentra disponible",
            titleModal: "Estás muy cerca de tu préstamo",
            bodyModal: <span>Se ha enviado un SMS a tu celular para que descargues la app y continúes con el proceso de préstamo que tienes con nosotros.</span>,
            resultBadgeText: "Resultado de solicitud",
            approvedText: "está aprobado",
            userName: "Usuario",
            advisorText: <>Un asesor de Apoyo Financiero se contactará contigo para la entrega de tu prestamo o comunícate al <a href="tel:18008912778">1-800-891-2778</a> (Opción 5)</>,
            summaryTitle: "Resumen del préstamo",
            montoLabel: "MONTO",
            pagoLabel: "PAGO",
            plazoLabel: "PLAZO",
            primerPagoLabel: "Primer pago",
            appsTitle: "Pagos rápidos y seguros desde tu celular.",
            appsSubtitle: "Descarga nuestra APP y maneja tu préstamo fácil, sin filas y sin complicaciones.",
            loanTitlePrefix: "¡Tu préstamo"
        },
        VDPNFelicidadesApp: {
            TitleAndroid: "Disponible en Google Play",
            TitleApple: "Descárgala en App Store"
        },
        VDPNLoSentimosAfi: {
            dataInfo: {
                textHeader: "Muchas gracias por tu interés en obtener un préstamo con nosotros.",
                textBox: "En este momento no reúnes los criterios necesarios para la aprobación de tu solicitud, esperamos poder apoyarte en el futuro en Apoyo Financiero.",
                textBoxTwo: "En los próximos días recibirás una comunicación por correo postal con más detalles, si tienes preguntas puedes llamar al 800-891-2778."
            },
            resultBadgeText: "Resultado de solicitud"
        },
        VDPNLoSentimosFico: {
            dataInfo: {
                textHeader: "Lo sentimos",
                textBox: "En este momento, usted no cumple con el requisito mínimo de puntaje FICO para solicitar un préstamo.",
                textBoxTwo: "Esperamos poder ayudarle en el futuro.",
                textBoxThree: ""
            },
            resultBadgeText: "Resultado de solicitud",
            offerTitle: {
                before: "¡Todavía tienes ",
                highlight: "una oportunidad!",
                after: ""
            },
            offerDescription: "Aplica a un préstamo con tu auto como garantía a través de nuestro socio comercial Loan Center.",
            offerPrimaryCta: "Descubre si calificas",
            smsButtonText: "Recibir enlace por SMS",
            smsSuccessMessage: "Mensaje enviado con éxito",
            smsErrorMessage: "Error al enviar el mensaje",
            callLinkPrefix: "Toca aquí para llamar",
            phoneNumber: "8005973594",
            phoneNumberFormatted: "800-597-3594.",
            phoneSubtext: "Atención en español disponible (solicítala al iniciar la llamada).",
            offerSecondaryCta: "No me interesa esta opción",
            reasonTitle: "¿Me podría indicar por qué no está interesado en esta opción?",
            saveReasonText: "Guardar motivo",
            reasonPlaceholder: "Especifica el motivo",
            reasonValidationMessage: "Selecciona un motivo antes de guardar.",
            reasonCommentValidationMessage: "Escribe un comentario antes de guardar.",
            reasonSavedMessage: "Motivo guardado con éxito.",
            reasonSaveErrorMessage: "No fue posible guardar el motivo.",
            interestReasons: [
                { key: 'no_vehicle_owner', label: 'No tengo un auto registrado a mi nombre.' },
                { key: 'no_collateral', label: 'No quiero dejar mi auto como garantía.' },
                { key: 'dont_know_lc', label: 'No conozco a Loan Center.' },
                { key: 'other_coment', label: 'Otro' }
            ]
        },
        VDPNformCard: {
            alertMessage: "Por el momento el servicio no se encuentra disponible",
            titulo: "¡Envíanos tus datos para dar el siguiente paso!",
            inName: "Nombre",
            inLastName: "Apellido",
            inPhone: "Teléfono",
            inCp: "Código Postal",
            subtitle: "¿Cuánto necesitas?",
            lblSend: "Continuar",
            lblInfo: <>Al hacer click en "continuar", aceptas enviar tu información a Apoyo Financiero, Inc, quien se compromete a usarla conforme a su politica de privacidad. Consulta aqui la <a href="/es/terminos-condiciones?option=privacy-notice-tx" target='_blank'  rel="nofollow noopener noreferrer" style={{ textDecoration: "underline",color:"#ff7a45"}}>Notificacion sobre los Derechos de Privacidad</a></>,
            lblInfoSend: "Espera la llamada de uno de nuestros representantes en breve para iniciar tu solicitud de préstamo.",
            dlgTitle: "¡Gracias por tu preferencia!",
            dlgBody: "Hemos recibido tus datos, en breve uno de nuestros ejecutivos se pondrá en contacto para continuar con tu solicitud.",
            dlgFooter: "Salir",
            warningModalTitle: "Campos incompletos",
            warningModalMessage: "Por favor, completa todos los campos obligatorios antes de continuar.",
            warningModalButton: "Aceptar"
        }
    }
}
